/**
 * ChapterSubPageRoute — resolves the `:chapterSlug` route param to its
 * `ChapterContent` and renders the shared `ChapterSubPage` template. An unknown
 * or unpublished slug renders a graceful not-found state (CX-2726 AC).
 *
 * Route: /circular-cmf-guide/:chapterSlug (gated by the `circularCmfGuide` flag)
 */

import { Breadcrumb } from "components/navigation";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { ChapterSubPage } from "./ChapterSubPage";
import "./ChapterSubPageRoute.css";
import { chapterContentBySlug } from "./chapters";

export const ChapterSubPageRoute = () => {
  const { t } = useTranslation();
  const { chapterSlug = "" } = useParams<{ chapterSlug: string }>();
  const content = chapterContentBySlug[chapterSlug];

  if (!content) {
    return (
      <div className="chapter-not-found">
        <Breadcrumb
          items={[
            { label: t("common_homepage", "Homepage"), to: "/", home: true },
            {
              label: t("cmf_guide_breadcrumb", "Circular CMF Guide"),
              to: "/circular-cmf-guide",
            },
            { label: chapterSlug },
          ]}
        />
        <div className="chapter-not-found__body">
          <span className="chapter-not-found__rule" aria-hidden="true" />
          <h1 className="chapter-not-found__title">
            {t("cmf_guide_chapter_not_found_title", "Chapter not found")}
          </h1>
          <p className="chapter-not-found__text">
            {t(
              "cmf_guide_chapter_not_found_text",
              "The requested chapter could not be found. Visit the guide to explore available chapters.",
            )}
          </p>
          <Link className="chapter-not-found__link" to="/circular-cmf-guide">
            {t("cmf_guide_back", "Back to Circular CMF Guide")}
          </Link>
        </div>
      </div>
    );
  }

  return <ChapterSubPage content={content} />;
};
